const VerticalMenu = ({ children }) => {
    return (
        <div className="vertical-menu">
            {children}
        </div>
    )
}

export default VerticalMenu;